// DAS-3119: value-trap badge for buy-side valuation alerts.
// "Value" when the company's fundamentals trend is improving, "Cheap, fundamentals
// deteriorating" when it is getting worse; nothing for Neutral, missing data,
// sell-side (Harvest) or alerts that are not driven by a valuation clause.
// Information only — the trend label predicts returns weakly (DAS-3014).

const BUY_SIDE_TYPES = ['accumulate', 'step in', 'monitor'];

const trendDate = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toISOString().slice(0, 10);
};

export default function valueTrapBadge(alert) {
  if (!alert || !alert.valuation_driven) return null;
  if (!BUY_SIDE_TYPES.includes((alert.alert_type || '').toLowerCase())) return null;

  const label = alert.fundamental_trend_label || '';
  let text;
  let color;
  if (label.endsWith('Improvement')) {
    text = 'Value';
    color = 'success';
  } else if (label.endsWith('Deterioration')) {
    text = 'Cheap, fundamentals deteriorating';
    color = 'warning';
  } else {
    return null;
  }

  const parts = [label];
  if (alert.fundamental_final_score !== null && alert.fundamental_final_score !== undefined) {
    parts.push(`score ${Math.round(Number(alert.fundamental_final_score))}`);
  }
  const date = trendDate(alert.fundamental_trend_updated_at);
  parts.push(date ? `fundamentals trend as of ${date}` : 'fundamentals trend');
  return { text, color, tooltip: parts.join(' · ') };
}
